import axios from 'axios';
import { apiURL } from '../constants/others';
import { clearLocalStorage, getLocalStorage } from './localstorage';

const API = axios.create({
    baseURL: apiURL,
});

export const getData = (endpoint, params, header = {}) => API.get(endpoint, { params, headers: header });

API.interceptors.request.use((req) => {
    const loader = document.getElementById("loader")
    loader.style.display = "flex"
    if (getLocalStorage("auth")) {
        req.headers.Authorization = `Bearer ${getLocalStorage("auth").token}`;
    }

    return req;
});

API.interceptors.response.use(
    (response) => {
        const loader = document.getElementById("loader")
        loader.style.display = "none"
        return response
    },
    (error) => {
        const loader = document.getElementById("loader")
        loader.style.display = "none"
        if (error.response && error.response.status === 401) {
            clearLocalStorage()
            window.location.href = "/login";
        }

        return Promise.reject(error);
    }
);


export const uploadImage = async (endpoint, e) => {
    try {
        const fd = new FormData();
        fd.append("file", e.target.files[0]);
        return await API.post(endpoint, fd, {});
    } catch (error) {
        console.log(error);
    }
};
export const postData = (endpoint, formData, config = {}) => API.post(endpoint, formData, config);
export const deleteData = (endpoint) => API.delete(endpoint)
export const updateData = (endpoint, data={}) => API.patch(endpoint, data);